import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { firstValueFrom } from 'rxjs';
import { onUserLogin } from 'src/app/Services/datadog-session';

import {
  CompanyPortalCompanyModel,
  UserModel,
  UserPermissionsModel,
  UsersModelForEmail
} from '../Models/ApplicationModels';
import { BreadcrumbService } from '../Services/breadcrumb.service';
import { CommonServiceService } from '../Services/common-service.service';
import { MasterDataSeriveService } from '../Services/master-data-serive.service';
import { SessionTimeoutService } from '../Services/session-timeout.service';
import { UserserviceService } from '../Services/userservice.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  userObj: UsersModelForEmail = new UsersModelForEmail();
  usersArray: Array<any> = [];
  userRolesPerm: UserPermissionsModel[] = [];
  company: CompanyPortalCompanyModel = new CompanyPortalCompanyModel();
  user: UserModel = new UserModel();
  userInfo: any;

  constructor(
    private userservice: UserserviceService,
    private route: Router,
    private masterservice: MasterDataSeriveService,
    private breadCrubService: BreadcrumbService,
    private sessionTimeoutService: SessionTimeoutService,
    private commonService: CommonServiceService
  ) {}

  async ngOnInit() {
    // AB#14151: only wipe storage when there's genuinely no valid session.
    // This route gets landed on for reasons that have nothing to do with the
    // session actually being dead - a permission-check guard bounce, a
    // cache-buster reload - and the previous unconditional clear() here
    // turned every one of those into a full forced-relogin: station
    // assignment, isBypassLicense, and all in-progress screen state gone,
    // even though the auth cookie was still perfectly valid.
    let token = this.userservice.getAuthToken();
    if (!token) {
      localStorage.clear();
      sessionStorage.clear();
      this.userservice.LogOut();
      return;
    }

    await this.userservice.getSessionStorageItem();
    this.userRolesPerm = await this.userservice.getUserRolesandPerm();
    await this.userDetails();
  }

  async userDetails() {
    this.userInfo = this.userservice.getUserFromLocalStorage();
    if (this.userInfo) {
      this.masterservice.getUserDetailsById(this.userInfo.userId).subscribe(async res => {
        if (res) {
          var newResponse = res;
          const oldResponse = this.userservice.transformResponse(newResponse);
          const userObj = JSON.stringify(oldResponse);
          localStorage.setItem('user', userObj);
          localStorage.removeItem('userDetails');
          localStorage.removeItem('tempStoreId');
          this.user = res as UserModel;
          let s_id = this.user.defaultStoreId;
          localStorage.setItem('storeId', JSON.stringify(s_id));

          sessionStorage.setItem('isBypassLicense', oldResponse.isBypassLicenses.toString());

          localStorage.setItem('sessionTimeoutMinutes', JSON.stringify(oldResponse.userSessionTimeout));

          var moduleId = this.user.defaultModuleId;

          if (!moduleId || [0, 3].includes(moduleId)) {
            this.route.navigateByUrl('/admin/home/admin-home');
          } else if (moduleId == 2) {
            sessionStorage.setItem('isFirstVisit', 'true');
            this.route.navigateByUrl('/production/home/departments');
          }
        }
      });
    } else {
      const returnUrl = encodeURIComponent(window.location.href);
      window.location.replace(`${environment.companyWebBaseUrl}/login?redirectTo=${returnUrl}`);
    }
  }
}
